import { StoreListState, StoreResponseProps } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getAllStore } from './storeService';

export const initialState: StoreListState = {
    data: {} as StoreResponseProps,
    status: "loading",
    error: {}
}

export const StoreSlice = createSlice({
    name: 'stores',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllStore.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getAllStore.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getAllStore.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const StoreListReducer = StoreSlice.reducer